'use client';

import { c as _c } from "react/compiler-runtime";
import './selectable-card.scss';
import type { ReactNode } from 'react';
export interface SelectableCardProps {
  checked: boolean;
  disabled?: boolean;
  onChange: () => void;
  children: ReactNode;
  checkIcon?: ReactNode;
}
export const SelectableCard: React.FC<SelectableCardProps> = t0 => {
  const $ = _c(20);
  const {
    checked,
    disabled: t1,
    onChange,
    children,
    checkIcon
  } = t0;
  const disabled = t1 === undefined ? false : t1;
  const t2 = checked && "SelectableCard--selected";
  const t3 = disabled && "SelectableCard--disabled";
  let t4;
  if ($[0] !== t2 || $[1] !== t3) {
    t4 = ["SelectableCard max-w-full flex gap-comfy-xs p-comfy-xs pl-comfy-sm justify-between overflow-hidden", t2, t3].filter(Boolean);
    $[0] = t2;
    $[1] = t3;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  const rootClasses = t4.join(" ");
  const t5 = checked && "SelectableCard__checkbox--selected";
  const t6 = disabled && "SelectableCard__checkbox--disabled";
  let t7;
  if ($[3] !== t5 || $[4] !== t6) {
    t7 = ["SelectableCard__checkbox flex shrink-0 items-center justify-center", t5, t6].filter(Boolean);
    $[3] = t5;
    $[4] = t6;
    $[5] = t7;
  } else {
    t7 = $[5];
  }
  const checkboxClasses = t7.join(" ");
  let t8;
  if ($[6] !== checked || $[7] !== disabled || $[8] !== onChange) {
    t8 = <input type="checkbox" checked={checked} disabled={disabled} onChange={onChange} className="sr-only" />;
    $[6] = checked;
    $[7] = disabled;
    $[8] = onChange;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== children || $[11] !== t8) {
    t9 = <div className="flex gap-comfy-xs flex-1 min-w-0">{t8}{children}</div>;
    $[10] = children;
    $[11] = t8;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  const t10 = checked && checkIcon;
  let t11;
  if ($[13] !== checkboxClasses || $[14] !== t10) {
    t11 = <span className={checkboxClasses} aria-hidden="true">{t10}</span>;
    $[13] = checkboxClasses;
    $[14] = t10;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  let t12;
  if ($[16] !== rootClasses || $[17] !== t11 || $[18] !== t9) {
    t12 = <label className={rootClasses}>{t9}{t11}</label>;
    $[16] = rootClasses;
    $[17] = t11;
    $[18] = t9;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  return t12;
};